import React, { useState, useEffect, useMemo } from 'react';
import TimerContext from './Timercontext';
import Loader from '../../Loader/buttonLoad';
import { useGetpresaletimer } from '../Home/HomepageApi';
import PropTypes from 'prop-types';

export const Timerprovider = ({ children }) => {
  const { data: presaletimer, isLoading, error } = useGetpresaletimer();
  
  // Timer state
  const [timer, setTimer] = useState({
    startTime: '',
    endTime: ''
  });

  const [visible, setVisible] = useState(true);
  const [days, setDays] = useState(0);

  const [hours, setHours] = useState(0);

  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const [endtime, setEndtime] = useState(0);
  const [presalevalue ,setPresalevalue] = useState(0)
  
  const value = useMemo(() => ({
    days,
    hours,
    minutes,
    seconds,
    visible,
    endtime,
    presalevalue
}), [days, hours, minutes, seconds, visible, endtime, presalevalue]);
  useEffect(() => {
    // Update the timer when presale data is available
    if (presaletimer?.data[0]) {
      setTimer({
        startTime: presaletimer.data[0].startdate ,
        endTime:  presaletimer.data[0].enddate,
        
      });
      setPresalevalue(presaletimer?.presalereward)
    }
  }, [presaletimer]);

  // Timer setup and countdown logic
  useEffect(() => {
    let countdownInterval;
 

     if (timer.endTime) {
      countdownInterval = setInterval(() => {
        const now = new Date();
        const endTime = new Date(timer.endTime*1000.0);
        const timeDiff = endTime - now;
        if (timeDiff > 0) {
          const _days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
          const _hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const _minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
          const _seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

          setDays(_days);
          setHours(_hours);
          setMinutes(_minutes);
          setSeconds(_seconds);
          setEndtime(endTime)
        } else {
          setVisible(false);
          clearInterval(countdownInterval);
        }
      }, 1000);
       
    }

    if(presaletimer?.data[0]?.status === "inactive"){
      setVisible(false);
    }
    return () => clearInterval(countdownInterval);
  }, [timer.endTime]);

  if (isLoading) return <Loader />;
  if (error) return <div>Error loading timer</div>;


  return (
    <TimerContext.Provider value={value}>
      {children}
    </TimerContext.Provider>
  );
};
Timerprovider.propTypes = {
    children: PropTypes.any,

}
export default Timerprovider;